export default __webpack_public_path__ + "static/media/postgraduate-glyph-16px.e36407c2.svg";